// Founder & brand constants
export const FOUNDER = {
  name: "Maria",
  fullTitle: "Maria — Founder of Calm & Connected",
  // Real photos of Maria
  portraitPrimary:
    "https://customer-assets.emergentagent.com/job_support-growth-1/artifacts/b0kaf8cd_c5a953cc-8c86-4ac6-8087-8e4c46a50741.jpg",
  portraitSecondary:
    "https://customer-assets.emergentagent.com/job_support-growth-1/artifacts/85qig5m7_ee20023e-8c21-492f-b601-c599b3e72a67.jpg",
  // Newest portraits
  portraitOutdoor:
    "https://customer-assets.emergentagent.com/job_support-growth-1/artifacts/kyqifsbz_4e42d196-ac8e-4df0-99a1-eed0b619cfc9.jpg",
  portraitCar:
    "https://customer-assets.emergentagent.com/job_support-growth-1/artifacts/u8rkfa8y_22520fa1-1eaf-4130-967d-950225305586.jpg",
};

// Brand logo (square asset with dark backdrop — designed as a badge)
export const BRAND = {
  logo:
    "https://customer-assets.emergentagent.com/job_support-growth-1/artifacts/dm28ip4u_d53e902f-dcb4-4b6d-bbd5-6cb1d5cb1043.png",
  name: "Calm & Connected",
  tagline: "Helping you stay calm, connected, and supported",
  email: "calmconnects@outlook.com",
  phone: "+15022494937",
  phoneDisplay: "(502) 249-4937",
  socials: {
    tiktok: "https://www.tiktok.com/@camilieyes",
    instagram: "https://instagram.com/",
  },
};
